import React from "react";
import { node, string } from "prop-types";

import LinkEnum from "./styled";

/**
 * @deprecated please use @streeteasy/design-system/text-action instead
 */
const TextLink = props => {
  const Link = LinkEnum[props.theme];

  return (
    // onTouchStart is added to trigger the CSS :active pseudo-class on tap for iPhones
    <Link as={props.asElement} onTouchStart={() => {}} {...props}>
      {props.children}
    </Link>
  );
};

TextLink.propTypes = {
  asElement: string,
  children: node.isRequired,
  href: string,
  textStyle: string,
  theme: string
};

TextLink.defaultProps = {
  asElement: "a",
  href: null,
  textStyle: "",
  theme: "primaryTouchedBoldUnderline"
};

export default TextLink;
